// extracted by mini-css-extract-plugin
export var industriesSection = "industries-module--industriesSection--1l1c3";
export var industriesTextWrapper = "industries-module--industriesTextWrapper--l07RB";
export var industriesMarqueeWrapper = "industries-module--industriesMarqueeWrapper--YCPlS";
export var industriesMarqueeWrapperMobile = "industries-module--industriesMarqueeWrapperMobile--KPYAw";
export var industriesMarqueeBox = "industries-module--industriesMarqueeBox--zXXfh";
export var industriesMarqueeWrapperDesktop = "industries-module--industriesMarqueeWrapperDesktop--FkIXR";
export var industriesMarqueeBoxes = "industries-module--industriesMarqueeBoxes--A3Pbw";